import React from 'react';
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import Header from '../components/Header';
import Footer from '../components/Footer';
import Home from '../pages/Home';
import About from '../pages/About';
import Work from '../pages/Work';
import Connect from '../pages/Connect';
import WorkSingle from '../pages/WorkSingle';
import PageNotFound from '../pages/PageNotFound';
import ScrollToTop from "../utilities/scrollToTop";
import works from '../data/works';

const AppRouter = () => (

	<Router>
		<ScrollToTop />
		<div className="wrapper">
			<Header />
			<Switch>
				<Route path={'/'} exact><Home /></Route>
				<Route path={'/about'}><About /></Route>
				<Route path={'/work'} exact><Work /></Route>
				<Route path={'/contact'}><Connect /></Route>
				
				{works.map((workObj, i) => {
                    return <Route 
					path={workObj.url} key={i} 
                    >
						<WorkSingle key={i} workObj={workObj} />
					</Route>
                })}

				<Route path={'/*'}><PageNotFound /></Route>
			</Switch>
			<Footer />
		</div>
	</Router>
	
);

export default AppRouter;
